import VideoUpload from "../../components/video/VideoUpload";

function CreateVideoPage(){

     return(
          <VideoUpload />
     )
}

export default CreateVideoPage;